import React, { ReactNode } from 'react';
import cl from 'classnames';

import { ClassName, FetchItemError } from '../../../../types';

import { MainLayout } from '../MainLayout';

import { DefaultSecondaryMenu } from '../../../common/components/menus/DefaultSecondaryMenu';

import { MainScrollWrapper } from '../../helpers/MainScrollWrapper';

interface ShowItemLayoutProps {
  action: string;
  banner?: ReactNode;
  children: ReactNode;
  customSecondaryMenu?: ReactNode;
  error?: FetchItemError;
  header?: ReactNode;
  headerWrapClassName?: ClassName;
  i18nTitle?: string;
  mainAddClassName?: ClassName;
  mainClassName?: ClassName;
  sidebar?: ReactNode;
  tabs?: ReactNode;
  title?: string;
  withoutActionError?: boolean;
  withoutSecondaryMenu?: boolean;
  withScrollToTop?: boolean;
}

function ShowItemLayout({
  action,
  banner,
  children,
  customSecondaryMenu,
  error,
  header,
  headerWrapClassName,
  i18nTitle,
  mainAddClassName,
  mainClassName,
  sidebar,
  tabs,
  title,
  withoutActionError,
  withoutSecondaryMenu,
  withScrollToTop
}: ShowItemLayoutProps) {
  return (
    <MainLayout
      action={action}
      withoutActionError={withoutActionError}
      i18nTitle={i18nTitle}
      title={title}
      error={error}
    >
      <div className="flex min-w-0 flex-1">
        <div id="page-wrap" className="flex min-w-0 flex-1 flex-col z-0">
          {header || tabs ? (
            <div
              id="page-header-wrap"
              className={cl(
                headerWrapClassName || 'relative bg-white dark:bg-gray-900'
              )}
            >
              {header}
              {tabs}
            </div>
          ) : null}

          {banner}

          {/* Page content wrapper */}
          <div className="relative flex-1 xl:z-0">
            <div className="absolute inset-0 flex overflow-hidden">
              {/* Page main content */}
              <MainScrollWrapper
                withScrollToTop={withScrollToTop}
                className={
                  mainClassName ||
                  cl(
                    'flex-1 relative overflow-y-auto focus:outline-none z-0 xl:z-15',
                    mainAddClassName
                  )
                }
              >
                {children}
              </MainScrollWrapper>
              {sidebar}
            </div>
          </div>
        </div>
        {withoutSecondaryMenu
          ? null
          : customSecondaryMenu || <DefaultSecondaryMenu />}
      </div>
    </MainLayout>
  );
}

export default ShowItemLayout;
